import { HttpClient, ListResponse } from '@amzn/dots-core-ui';
import { BuildFileUri, BuildUri } from '$/features/routes';
import { Project, Build, BuildFile } from './models';
import { BaseApi, BaseGetAllFilter, baseApiFactory } from '../baseApi';

export type ProjectId = Project['id'];
export type ProjectName = Project['name'];
export type BuildVersion = Build['version'];

export type ProjectAllFilter = BaseGetAllFilter<ProjectId>;

export type ProjectApi = BaseApi<ProjectId, Project, ProjectAllFilter> & {
  getVersions: (projectName: ProjectName) => Promise<ListResponse<Build>>;
  getBuildFiles: (
    projectName: ProjectName,
    buildVersion: BuildVersion
  ) => Promise<ListResponse<BuildFile>>;
  getProjectNames: (name: string) => Promise<ListResponse<string>>;
};

export const ProjectClient = (client: HttpClient): ProjectApi => ({
  ...baseApiFactory(client, 'project'),
  getVersions: (projectName: ProjectName): Promise<ListResponse<Build>> =>
    client.get({
      url: `${BuildUri}?name=${projectName}`,
    }),
  getBuildFiles: (
    projectName: ProjectName,
    buildVersion: BuildVersion
  ): Promise<ListResponse<BuildFile>> =>
    client.get({
      url: `${BuildFileUri}?name=${projectName}&version=${buildVersion}`,
    }),
  getProjectNames: (name: string): Promise<ListResponse<string>> =>
    client.get({ url: `/project?name=${name}` }),
});
